import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography, TableFooter } from '@mui/material';
import { orderContext } from '../OrderContext';
import { CircleLoader, DetailsPageHeader } from 'components';
import Moment from 'react-moment';
import { applicationContext } from 'helpers/services';

let DUESyncErrors = () => {
    let service = useContext(orderContext);
    let appService = useContext(applicationContext);

    return (
        <DetailsPageHeader sectionName='DUE sync errrors'>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Error type</TableCell>
                            <TableCell>Errors</TableCell>
                            <TableCell align='center'>Retry</TableCell>
                            <TableCell>Last retry</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(service.order.erpSyncErrors && service.order.erpSyncErrors.errors.length !== 0) &&
                            <TableRow hover>
                                <TableCell style={{ whiteSpace: 'nowrap' }}>{appService.referenceData.DUESyncError.getValueByKey(service.order.erpSyncErrors.errorType)}</TableCell>
                                <TableCell>{service.order.erpSyncErrors.errors}</TableCell>
                                <TableCell align='center'>{service.order.erpSyncErrors.retryNr}</TableCell>
                                <TableCell>
                                    <Moment date={service.order.erpSyncErrors.lastRetry} format="LLL" />
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                    {(!service.order.erpSyncErrors || service.order.erpSyncErrors.errors.length === 0) &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={4}>
                                    <Typography variant="subtitle2">No errors found</Typography>
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>
            }
        </DetailsPageHeader>
    );
}

export default DUESyncErrors;